<script setup lang="ts">
  import { computed } from "vue";
  import { Text } from "@ui-kit";
  import { useProfileOptions } from "@src/hooks";
  import { useWidgetsStore } from "@src/store";
  import MainPageAction from "./MainPageAction.vue";

  const { hasPermission } = useProfileOptions();
  const widgets_store = useWidgetsStore();

  const is_available_action = computed(() => {
    return hasPermission("mobile.stat.moneymap");
  });
</script>

<template>
  <MainPageAction
    v-if="is_available_action"
    @click="() => widgets_store.open('moneymap')"
    data-testid="action-moneymap"
  >
    <template #icon>
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M25 37V11C25 10.4477 25.4477 10 26 10C26.5523 10 27 10.4477 27 11V37M25 37L18 37M25 37H27M16 37H11V38H41V37L36 37M16 37V20C16 19.4477 16.4477 19 17 19C17.5523 19 18 19.4477 18 20V37M16 37H18M34 37V26C34 25.4477 34.4477 25 35 25C35.5523 25 36 25.4477 36 26V37M34 37H27M34 37H36"
          stroke="var(--sf-illustration-primary-background-primary)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 35V9C20 8.44771 20.4477 8 21 8C21.5523 8 22 8.44772 22 9V35M20 35L13 35M20 35H22M11 35H6V36H36V35L31 35M11 35V18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18V35M11 35H13M29 35V24C29 23.4477 29.4477 23 30 23C30.5523 23 31 23.4477 31 24V35M29 35H22M29 35H31"
          stroke="var(--sf-illustration-primary-border)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Money mapping") }}</Text>
    </template>
  </MainPageAction>
</template>
